import { Box, Typography, Grid, useTheme } from "@mui/material";
import WhoWeHelpContent from "../../data/WhoWeHelpContent";
import IconListItem from "../common/IconListItem";
import TaskAltIcon from "@mui/icons-material/TaskAlt";
import { iconsMap } from "../utils/iconsMap";
import SectionMainTitle from "../common/SectionMainTitle";
import ParallaxBackground from "../common/ParallaxBackground";
import useResponsiveSpacingGrid from "../../hooks/useResponsiveSpacingGrid";

const WhoWeHelpSection: React.FC = () => {
  const theme = useTheme();
  const spacing = useResponsiveSpacingGrid();

  return (
    <ParallaxBackground backgroundImage="/assets/bgIngCivil1.jpg">
      {/* Título principal */}
      <SectionMainTitle title={WhoWeHelpContent.title} mb={spacing} />

      {/* Columna izquierda: Key Traits */}
      <Grid size={{ xs: 12, md: 6 }} mt={2}>
        <Typography
          variant="h4"
          sx={{
            color: theme.palette.primary.main,
            fontWeight: 800,
            mb: spacing,
            textAlign: { xs: "left", md: "left" },
          }}
        >
          {" "}
          {WhoWeHelpContent.subtitle}
        </Typography>

        <Grid container spacing={spacing} alignItems="stretch">
          {WhoWeHelpContent.keyTraits.map((trait, index) => (
            <Grid size={{ xs: 12, md: 6 }} key={index}>
              <Box
                sx={{
                  backgroundColor: theme.palette.background.paper,
                  border: `1px solid ${theme.palette.divider}`,
                  padding: theme.spacing(3),
                  borderRadius: 2,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-start",
                }}
              >
                <IconListItem
                  key={index}
                  title={trait.title}
                  text={trait.value}
                  icon={
                    <TaskAltIcon
                      sx={{
                        color: theme.palette.primary.main,
                        mt: "3px",
                      }}
                    />
                  }
                />
              </Box>
            </Grid>
          ))}
        </Grid>
      </Grid>

      {/* Columna derecha: Challenges */}
      <Grid size={{ xs: 12, md: 6 }} sx={{ my: 6 }}>
        <Typography
          variant="h4"
          sx={{
            color: theme.palette.challenge.main,
            fontWeight: 700,
            mb: spacing,
            textAlign: {
              xs: "left",
              md: "left",
            },
          }}
        >
          {WhoWeHelpContent.challengesTitle}
        </Typography>

        <Grid container spacing={spacing} alignItems="stretch">
          {WhoWeHelpContent.challenges.map((challenge, index) => {
            const IconComponent =
              iconsMap[challenge.icon] || iconsMap["CheckCircleIcon"];
            return (
              <Grid size={{ xs: 12, md: 6 }} key={index}>
                <Box
                  sx={{
                    backgroundColor: theme.palette.challengeBox.background,
                    border: `1px solid ${theme.palette.challengeBox.border}`,
                    borderRadius: 2,
                    padding: 3,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                  }}
                >
                  <IconListItem
                    key={index}
                    title={challenge.title}
                    text={challenge.value}
                    icon={
                      <IconComponent
                        sx={{
                          color: theme.palette.challengeBox.icon,
                          mt: "3px",
                        }}
                      />
                    }
                  />
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    </ParallaxBackground>
  );
};

export default WhoWeHelpSection;
